import React from "react";
import { Modal, ModalBody } from "reactstrap";
import styles from "./productdetail.module.scss";
import Proptypes from "prop-types";

import Content from "./Content/Content";

const ProductDetailModal = ({
  currentProduct,
  openModal,
  toggle,
  setOpenEditProductModal,
}) => {
  const colorsArray = currentProduct?.colors?.split(",") || [];

  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="md"
        contentClassName={styles["modal_content"]}
        className={styles["modal_product_container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_location_body"]}>
          <Content
            currentProduct={currentProduct}
            setOpenEditProductModal={setOpenEditProductModal}
            toggle={toggle}
            colorsArray={colorsArray}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

ProductDetailModal.propTypes = {
  currentProduct: Proptypes.object,
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
  setOpenEditProductModal: Proptypes.func,
};

export default ProductDetailModal;
